import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import './index.scss'

export default function BasicCTABanner ({component}) {
const {headline, description, bannerImage, background, imageAlignment, cta} = component;   
const bg = background[0];

    return (
        <section data-datocms-noindex className="basic-cta-banner" style={{ backgroundColor: bg.hasBackgroundImage ? "#fff" : bg.backgroundColor }}>
            {
                bg.hasBackgroundImage &&
                <GatsbyImage image={getImage(bg.image)} alt={headline} className="basic-cta-banner__bg"/>
            }
            <div className="container">
                <div className={`row ${ imageAlignment === "left" && "row-reverse"}`}>
                    <div className="col-lg-5 basic-cta-banner__content">
                        <h3 className="oblique text-white">{headline}</h3>
                        <p className="basic-cta-banner__description text-white">{description}</p>
                        {
                            cta[0].linkUrl
                            &&
                            <Link to={cta[0].linkUrl} className="btn btn-primary">{cta[0].label}</Link>
                        }
                    </div>
                    <div className="col-lg-1"></div>
                    <div className="col-lg-6 basic-cta-banner__image-wrapper">
                        <GatsbyImage image={getImage(bannerImage)} alt={headline} className="basic-cta-banner__image"/>
                    </div>
                </div>
            </div>
        </section>
    )
}